/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Explorer_Display_Delete_Success_ToastInputs */



/**
* | output |
* | --- |
* | "{count} record(s) deleted successfully" |
*
* @param {Explorer_Display_Delete_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_delete_success_toast = /** @type {((inputs: Explorer_Display_Delete_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Delete_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} enregistrement(s) supprime(s) avec succes`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count}-Datensatz(e) erfolgreich gelöscht`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} record eliminati con successo`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Запись(и) ${i?.count} успешно удалена(ы).`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} registro(s) eliminado(s) exitosamente`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.count} 记录已成功删除`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} 件のレコードが正常に削除されました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} रिकॉर्ड सफलतापूर्वक हटा दिए गए`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Registro(s) ${i?.count} excluído(s) com sucesso`)
	return /** @type {LocalizedString} */ (`${i?.count} record(s) deleted successfully`)
});